import React from 'react';

import { GenericSimpleToggleButton } from 'com-gyf-webcore-userinterfacecomponents';

const BlockedPopUp = (props) => {
    return (
        <div className="dropdown">
            <GenericSimpleToggleButton text="BLOQUEADO" buttonType="btn btn-primary btn-tag" toggleType="dropdown" />
            <ul className="dropdown-menu">
                <li>
                    <p>Bloqueado por {props.informacionUsuario.BloqueadoPor} el {props.informacionUsuario.FechaBloqueo}</p>
                    <p><i>{props.informacionUsuario.MotivoBloqueo}</i></p>
                </li>
            </ul>
        </div>
    );
}

export default BlockedPopUp;